export default `float de(vec3 p){
    float rt = 15.;
    float rg = 4.;
    float ws = 0.3;

    p.xz = vec2(rt * atan (p.z, - p.x), length (p.xz) - rt);
    p.yz = vec2(rg * atan (p.z, - p.y), length (p.yz) - rg);
    return .6* max(abs(dot(sin(p), cos(p).yzx)) - ws, abs(p.z) - .5*PI);
  }`